import { Api } from "./Api.class";
const endpoint = "results";
const ResultsAPI = new Api(endpoint);
export default ResultsAPI;
